var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("404 Error")]),_c('p',[_vm._v("The resource could not be found.")]),_c('router-link',{attrs:{"to":"/","exact":""}},[_vm._v("\n        Go to home page\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }